import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Spinner } from './Spinner';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md';
  loading?: boolean;
  icon?: ReactNode;
  /** Labels may wrap (handheld apps, long translations); the console keeps them on one line. */
  wrap?: boolean;
}

export function Button({
  variant = 'primary',
  size = 'md',
  loading,
  icon,
  wrap,
  className,
  children,
  disabled,
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={[
        'nyk-ui-btn',
        `nyk-ui-btn-${variant}`,
        size === 'sm' ? 'nyk-ui-btn-sm' : '',
        wrap ? 'nyk-ui-btn-wrap' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? <Spinner /> : icon}
      {children}
    </button>
  );
}
